var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoColor0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "51px",
    viewBox: "0 0 51 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 26 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 51,
    height: 51,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "99.9996802%",
    x2: "50%",
    y2: "-0.00054373031%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6236FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4FE3",
    offset: "15.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#468D9F",
    offset: "55.79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B473",
    offset: "85.11%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34C363",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-6",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26-Copy"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#D8D8D8",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "zevio-icon-(1)",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_6_"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero",
    mask: "url(#mask-4)",
    x: 0,
    y: -0.835722656,
    width: 51,
    height: 62.2867383
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_9_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7404142,10.8474242 L51,24.4330834 L51,39.5352547 C51,42.2991973 50.0349157,44.7848916 48.1047471,46.9923376 C46.1745785,49.1997836 43.9234153,50.535671 41.3512575,51 L22.7640924,51.1992187 L10.7839876,38.4492188 C11.1797899,37.6383718 11.6977695,37.3063405 12.3379262,37.453125 C16.2170373,38.3425841 8.3100933,28.9388655 8.21539488,25.6992188 C8.03458252,19.5136019 12.5811405,16.1880072 15.3262698,12.2519531 C17.5925411,9.00250083 22.4172128,7.66692203 27.7900439,9.26367188 C31.405602,10.3381784 36.9024824,15.3446613 35.8797173,12.1742578 C35.5455428,11.1383716 36.1657751,10.6960937 37.7404142,10.8474242 Z",
    id: "Path-2",
    fillOpacity: 0.1,
    fill: "#000000",
    mask: "url(#mask-7)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.5491333,15.5047727 C39.9148869,12.545303 37.6500728,10.2220455 34.7556967,8.5330303 C31.8613206,6.84401515 28.6270213,6 25.051793,6 C21.443377,6 18.1909753,6.84401515 15.2976049,8.5330303 C12.4032288,10.2210606 10.1293635,12.5541667 8.47802038,15.5323485 C6.82567156,18.5095455 6,21.8334091 6,25.5 C6,29.1665909 6.82567156,32.4904545 8.47701469,35.4676515 C10.1283578,38.4448485 12.4022231,40.7779545 15.2965992,42.4669697 C18.1909753,44.155 21.4423713,45 25.0507873,45 C28.6270213,45 31.8603149,44.1559848 34.754691,42.4669697 C37.6490671,40.7779545 39.9138812,38.454697 41.5481276,35.4952273 C43.182374,32.5357576 44,29.2040152 44,25.5 C44,21.7959848 43.1833796,18.4642424 41.5491333,15.5047727 Z M37.0798465,32.9887879 C35.871007,35.2224242 34.2206696,36.9744697 32.1268228,38.2459091 C30.032976,39.5163636 27.6746328,40.1525758 25.051793,40.1525758 C22.429959,40.1525758 20.0555247,39.5173485 17.9264788,38.2459091 C15.7984385,36.9754545 14.1299987,35.2224242 12.9211592,32.9887879 C12.3147281,31.8680303 11.8601561,30.6822727 11.5584491,29.4285606 C12.7290724,30.8585606 14.4488024,31.7636364 16.3686648,31.7636364 C19.8946143,31.7636364 22.7527855,28.7155303 22.7527855,24.9553788 C22.7527855,21.1952273 19.8946143,18.1471212 16.3686648,18.1471212 C14.7052534,18.1471212 13.1896784,18.8266667 12.0542543,19.9385606 C12.2966256,19.2757576 12.5852587,18.6336364 12.9211592,18.0112121 C14.1299987,15.7775758 15.7974328,14.0255303 17.9264788,12.7540909 C20.0555247,11.4826515 22.429959,10.8474242 25.051793,10.8474242 C27.6746328,10.8474242 30.0319704,11.4826515 32.1268228,12.7540909 C34.2206696,14.0245455 35.871007,15.7775758 37.0798465,18.0112121 C38.288686,20.2448485 38.8931057,22.7404545 38.8931057,25.5 C38.8931057,28.2595455 38.288686,30.7561364 37.0798465,32.9887879 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColor0);
export default __webpack_public_path__ + "static/media/logo-color-0.8a572bad21bf4a3827522ee65744e313.svg";
export { ForwardRef as ReactComponent };